var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImport01 = function SvgImport01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "import-01_svg2__a",
    x1: -0.67,
    x2: 159.42,
    y1: 170.06,
    y2: 9.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#import-01_svg2__a",
    id: "import-01_svg2__b",
    x1: 41.61,
    x2: 201.7,
    y1: 212.34,
    y2: 52.25
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M86.89 124.68c3.48 3.48 8.19 5.43 13.11 5.43s9.64-1.95 13.11-5.43l39.14-39.14A7.25 7.25 0 0 0 142 75.29l-34.76 34.76V11.23c0-4-3.24-7.25-7.25-7.25s-7.25 3.24-7.25 7.25v98.83L57.98 75.3a7.237 7.237 0 0 0-10.24 0 7.237 7.237 0 0 0 0 10.24l39.14 39.14Z",
    style: {
      fill: "url(#import-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.75 118.9c-4 0-7.25 3.24-7.25 7.25v50.66c0 2.6-2.11 4.72-4.72 4.72H19.21c-2.6 0-4.72-2.11-4.72-4.72v-50.66c0-4-3.24-7.25-7.25-7.25s-7.25 3.24-7.25 7.25v50.66c.01 10.6 8.61 19.2 19.21 19.21h161.58c10.6-.01 19.2-8.61 19.21-19.21v-50.66c0-4-3.24-7.25-7.25-7.25Z",
    style: {
      fill: "url(#import-01_svg2__b)"
    }
  }));
};
export default SvgImport01;